import { useNavigate, useLocation } from 'react-router-dom';
import { history, uxscreen } from './_services/essentials/helpers';
import { AppLayout, WebLayout, AppAlertBox } from './_components';
import { Poster } from '_pages/web';
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import {breadcrumbsActions} from "./_services/essentials/store";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";

export { App };

function App() {
    // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();
    history.location = useLocation();
    const auth = useSelector(x => x.auth.value);
    const dispatch = useDispatch();

    if(history.location && history.location.pathname && history.location.pathname.trim() !=='/navigate') {
        // setTimeout(function() {
        //     alert(history.location.state ? JSON.stringify(history.location.state) : '');
        // }, 2000);
        dispatch(breadcrumbsActions.setCurrentURL(history.location.pathname));
    }

    return (
        <Box>
            {auth ? (
                <AppLayout />
            ) : (
                <WebLayout />
            )}
        </Box>
    );
}

